/* eslint-disable no-empty, no-redeclare, no-unused-vars */

import { $ as jquery } from 'jquery';
import { i18n } from '../core/i18n.js';
import { upload } from './upload.js';
import { layer } from './layer.js';

var $ = jquery;

var clamp = function (value, min, max) {
	return Math.min(Math.max(value, min), max);
};

var getEventPoint = function (event) {
	var originalEvent = event.originalEvent || event;
	var point =
		(originalEvent.touches && originalEvent.touches[0]) ||
		(originalEvent.changedTouches && originalEvent.changedTouches[0]) ||
		originalEvent;

	return {
		x: point.pageX,
		y: point.pageY
	};
};

var fitRectToAspect = function (width, height, aspectRatio) {
	if (width / height > aspectRatio) {
		width = height * aspectRatio;
	} else {
		height = width / aspectRatio;
	}

	return {
		w: width,
		h: height
	};
};

i18n.set({
	messages: {
		'zh-CN': {
			jcropFace: {
				uploadImage: '上传图片',
				uploading: '正在上传中...',
				uploadTips: '只支持JPG、JPEG、PNG、GIF大小不能超过2M',
				preview: '预览',
				previewTipsLead: '拖拽或缩放虚线框',
				previewTipsTrail: '生成所需尺寸图像',
				confirm: '确定',
				reset: '重做',
				close: '关闭',
				networkError: '网络异常',
				selectCropArea: '请选择裁剪区域',
				uploadFirst: '请先上传图片'
			}
		},
		'en-US': {
			jcropFace: {
				uploadImage: 'Upload Image',
				uploading: 'Uploading...',
				uploadTips:
					'Only JPG, JPEG, PNG and GIF are supported, size must not exceed 2MB',
				preview: 'Preview',
				previewTipsLead: 'Drag or resize the dashed box',
				previewTipsTrail: 'to generate the target image',
				confirm: 'Confirm',
				reset: 'Reset',
				close: 'Close',
				networkError: 'Network error',
				selectCropArea: 'Please select a crop area',
				uploadFirst: 'Please upload an image first'
			}
		}
	}
});

function JcropFace() {}

var jcropFace = JcropFace;
jcropFace.prototype.options = {};
var getDialogMetrics = function () {
	var viewportWidth =
		window.innerWidth || document.documentElement.clientWidth || 1024;
	var viewportHeight =
		window.innerHeight || document.documentElement.clientHeight || 768;
	var stacked = viewportWidth <= 900;
	var compact = viewportWidth <= 640;
	var gutter = compact ? 8 : viewportWidth <= 768 ? 16 : 48;
	var minWidth = compact ? 280 : 420;
	var minHeight = compact ? 320 : 440;
	var width = compact
		? viewportWidth - gutter
		: Math.min(920, viewportWidth - gutter);
	var height = compact
		? viewportHeight
		: Math.min(760, viewportHeight - gutter);

	width = Math.max(width, Math.min(minWidth, viewportWidth - 8));
	height = compact
		? Math.max(height, Math.min(minHeight, viewportHeight))
		: Math.max(height, Math.min(minHeight, viewportHeight - 8));

	var dialogHeight = Math.max(height - (compact ? 12 : 32), compact ? 308 : 408);
	var stageHeight;

	if (stacked) {
		stageHeight = Math.min(
			Math.max(dialogHeight - (compact ? 330 : 290), compact ? 140 : 180),
			compact ? 240 : 300
		);
	} else {
		stageHeight = Math.min(
			Math.max(dialogHeight - 112, 300),
			460
		);
	}

	return {
		area: [Math.round(width) + 'px', Math.round(height) + 'px'],
		dialogHeight: Math.round(dialogHeight) + 'px',
		stageHeight: Math.round(stageHeight) + 'px'
	};
};

jcropFace.prototype.init = function (options) {
	this.options = options;
	this._state = this._state || {
		layerIndex: null
	};

	var title = this.options.title;
	var type_big = this.options.type_big;
	var type_small = this.options.type_small;
	var object_type = this.options.object_type ? this.options.object_type : 0;
	var jcrop_face_big = this.options.elem + '_jcrop_face_big';
	var jcrop_face_small = this.options.elem + '_jcrop_face_small';
	var jcrop_face = this.options.elem + '_jcrop_face';
	var upload_image_btn = this.options.elem + '_upload_image_btn';
	var upload_image_msg = this.options.elem + '_upload_image_msg';
	var uploadUrl = this.options.uploadUrl;
	var size = this.options.size;
	var acceptMime = this.options.acceptMime;
	var headers = this.options.headers;
	var field = this.options.field;
	var exts = this.options.exts;
	var uploadData = this.options.uploadData;
	var cropUrl = this.options.cropUrl;
	var callback = this.options.callback;
	var jcrop_face_img = this.options.elem + '_jcrop_face_img';
	var pointerNamespace = '.jcropFaceCrop-' + this.options.elem;
	var t = function (key, fallback) {
		return i18n.translate('jcropFace.' + key, null, { default: fallback });
	};

	var type_big_x = parseFloat(type_big.split('x')[0]);
	var type_big_y = parseFloat(type_big.split('x')[1]);
	var aspectRatio = type_big_x / type_big_y;
	var type_small_x;
	var type_small_y;

	if (type_small) {
		type_small_x = parseFloat(type_small.split('x')[0]);
		type_small_y = parseFloat(type_small.split('x')[1]);
	}

	if ($('#' + jcrop_face).length > 0) {
		return;
	}

	var html = '';
	html += '<div class="jcrop-face" id="' + jcrop_face + '">';
	html += '<div class="jcrop-face-left">';
	html += '<h3 class="jcrop-face-move">' + title + '<span class="jcrop-face-error"></span></h3>';
	html += '<div class="jcrop-face-upload">';
	html +=
		'<a class="layui-btn" class="upload-image-btn" id="' +
		upload_image_btn +
		'" data="0"><i class="layui-icon">&#xe654;</i>' +
		t('uploadImage', '上传图片') +
		'</a>';
	html += '<p id="' + upload_image_msg + '" class="upload-image-error"></p>';
	html += '<p>' + t('uploadTips', '只支持JPG、JPEG、PNG、GIF大小不能超过2M') + '</p>';
	html += '</div>';
	html += '<div class="jcrop-face-content"></div>';
	html += '</div>';
	html += '<div class="jcrop-face-right">';
	html += '<h3>' + t('preview', '预览') + '</h3>';
	html +=
		'<p><span>' +
		t('previewTipsLead', '拖拽或缩放虚线框') +
		'</span><span>' +
		t('previewTipsTrail', '生成所需尺寸图像') +
		'</span></p>';
	html += '<div class="jcrop-face-big">';
	html += '<div id="' + jcrop_face_big + '">';
	html +=
		'<div class="jcrop-face-container" style="height:' +
		(120 / type_big_x) * type_big_y +
		'px;width:120px;"></div>';
	html += '</div>';
	html += '<p>' + type_big + '</p>';
	html += '</div>';

	if (type_small) {
		html += '<div class="jcrop-face-small">';
		html += '<div id="' + jcrop_face_small + '">';
		html +=
			'<div class="jcrop-face-container" style="height:' +
			(60 / type_small_x) * type_small_y +
			'px;width:60px;"></div>';
		html += '</div>';
		html += '<p>' + type_small + '</p>';
		html += '</div>';
	}

	html += '<div class="jcrop-face-btn">';
	html += '<a class="layui-btn jcrop-face-success">' + t('confirm', '确定') + '</a>';
	html +=
		'<a class="layui-btn layui-btn-primary jcrop-face-reset">' +
		t('reset', '重做') +
		'</a>';
	html +=
		'<a class="layui-btn layui-btn-danger jcrop-face-close">' +
		t('close', '关闭') +
		'</a>';
	html += '</div>';
	html += '</div>';
	html += '</div>';

	$('body').append(html);

	function loadImage(url, onSuccess, onError) {
		var img = new Image();
		img.src = url;

		if (img.complete) {
			return onSuccess(img);
		}

		img.onload = function () {
			img.onload = null;
			onSuccess(img);
		};

		img.onerror = function (event) {
			img.onerror = null;
			onError(event);
		};
	}

	var jcrop_x = 0;
	var jcrop_y = 0;
	var jcrop_w = 0;
	var jcrop_h = 0;
	var jcrop_id = 0;
	var cropType = '';
	var cropper = null;
	var dragging = null;
	var isCropping = false;

	var clearPreview = function () {
		jcrop_x = 0;
		jcrop_y = 0;
		jcrop_w = 0;
		jcrop_h = 0;
	};

	var updatePreview = function (rect) {
		if (!cropper || !rect) {
			clearPreview();
			return;
		}

		var scale = cropper.scale;
		var previewImageWidth = cropper.displayWidth;
		var previewImageHeight = cropper.displayHeight;
		var cropImageScale = cropper.cropImageScale;

		jcrop_x = Math.round((rect.x / scale) * cropImageScale);
		jcrop_y = Math.round((rect.y / scale) * cropImageScale);
		jcrop_w = Math.round((rect.w / scale) * cropImageScale);
		jcrop_h = Math.round((rect.h / scale) * cropImageScale);

		var bigScaleX = 120 / rect.w;
		var bigScaleY = ((120 / type_big_x) * type_big_y) / rect.h;

		$('#' + jcrop_face_big + ' .jcrop-face-container img').css({
			width: Math.round(bigScaleX * previewImageWidth) + 'px',
			height: Math.round(bigScaleY * previewImageHeight) + 'px',
			marginLeft: '-' + Math.round(bigScaleX * rect.x) + 'px',
			marginTop: '-' + Math.round(bigScaleY * rect.y) + 'px'
		});

		if (type_small) {
			var smallScaleX = 60 / rect.w;
			var smallScaleY = ((60 / type_small_x) * type_small_y) / rect.h;

			$('#' + jcrop_face_small + ' .jcrop-face-container img').css({
				width: Math.round(smallScaleX * previewImageWidth) + 'px',
				height: Math.round(smallScaleY * previewImageHeight) + 'px',
				marginLeft: '-' + Math.round(smallScaleX * rect.x) + 'px',
				marginTop: '-' + Math.round(smallScaleY * rect.y) + 'px'
			});
		}
	};

	var renderSelection = function () {
		if (!cropper || !cropper.selection) {
			clearPreview();
			return;
		}

		cropper.$selection.css({
			left: cropper.selection.x + 'px',
			top: cropper.selection.y + 'px',
			width: cropper.selection.w + 'px',
			height: cropper.selection.h + 'px'
		});

		updatePreview(cropper.selection);
	};

	var createInitialSelection = function () {
		var width = cropper.displayWidth;
		var height = cropper.displayHeight;
		var targetWidth = width * 0.68;
		var targetHeight = targetWidth / aspectRatio;

		if (targetHeight > height * 0.68) {
			targetHeight = height * 0.68;
			targetWidth = targetHeight * aspectRatio;
		}

		if (targetWidth > width || targetHeight > height) {
			var fitted = fitRectToAspect(width, height, aspectRatio);
			targetWidth = fitted.w;
			targetHeight = fitted.h;
		}

		return {
			x: Math.round((width - targetWidth) / 2),
			y: Math.round((height - targetHeight) / 2),
			w: Math.round(targetWidth),
			h: Math.round(targetHeight)
		};
	};

	var calculateMovedSelection = function (startRect, dx, dy) {
		var maxX = cropper.displayWidth - startRect.w;
		var maxY = cropper.displayHeight - startRect.h;

		return {
			x: clamp(startRect.x + dx, 0, maxX),
			y: clamp(startRect.y + dy, 0, maxY),
			w: startRect.w,
			h: startRect.h
		};
	};

	var calculateResizedSelection = function (handle, startRect, dx, dy) {
		var anchorX;
		var anchorY;
		var widthByX = 0;
		var widthByY = 0;
		var width;
		var maxWidth;
		var minHeight = 40;
		var minWidth = minHeight * aspectRatio;

		switch (handle) {
			case 'nw':
				anchorX = startRect.x + startRect.w;
				anchorY = startRect.y + startRect.h;
				widthByX = anchorX - (startRect.x + dx);
				widthByY = (anchorY - (startRect.y + dy)) * aspectRatio;
				maxWidth = Math.min(anchorX, anchorY * aspectRatio);
				width = clamp(Math.max(widthByX, widthByY), minWidth, maxWidth);
				return {
					x: anchorX - width,
					y: anchorY - width / aspectRatio,
					w: width,
					h: width / aspectRatio
				};
			case 'ne':
				anchorX = startRect.x;
				anchorY = startRect.y + startRect.h;
				widthByX = startRect.w + dx;
				widthByY = (anchorY - (startRect.y + dy)) * aspectRatio;
				maxWidth = Math.min(
					cropper.displayWidth - anchorX,
					anchorY * aspectRatio
				);
				width = clamp(Math.max(widthByX, widthByY), minWidth, maxWidth);
				return {
					x: anchorX,
					y: anchorY - width / aspectRatio,
					w: width,
					h: width / aspectRatio
				};
			case 'sw':
				anchorX = startRect.x + startRect.w;
				anchorY = startRect.y;
				widthByX = anchorX - (startRect.x + dx);
				widthByY = (startRect.h + dy) * aspectRatio;
				maxWidth = Math.min(
					anchorX,
					(cropper.displayHeight - anchorY) * aspectRatio
				);
				width = clamp(Math.max(widthByX, widthByY), minWidth, maxWidth);
				return {
					x: anchorX - width,
					y: anchorY,
					w: width,
					h: width / aspectRatio
				};
			case 'se':
			default:
				anchorX = startRect.x;
				anchorY = startRect.y;
				widthByX = startRect.w + dx;
				widthByY = (startRect.h + dy) * aspectRatio;
				maxWidth = Math.min(
					cropper.displayWidth - anchorX,
					(cropper.displayHeight - anchorY) * aspectRatio
				);
				width = clamp(Math.max(widthByX, widthByY), minWidth, maxWidth);
				return {
					x: anchorX,
					y: anchorY,
					w: width,
					h: width / aspectRatio
				};
		}
	};

	var stopDragging = function () {
		dragging = null;
		$(document).off(pointerNamespace);
	};

	var destroyCropper = function () {
		stopDragging();
		cropper = null;
		clearPreview();
	};

	var startDragging = function (mode, handle, event) {
		if (!cropper || !cropper.selection) {
			return;
		}

		var point = getEventPoint(event);
		dragging = {
			mode: mode,
			handle: handle,
			startX: point.x,
			startY: point.y,
			startRect: $.extend({}, cropper.selection)
		};

		$(document)
			.off(pointerNamespace)
			.on('pointermove' + pointerNamespace, function (moveEvent) {
				if (!dragging || !cropper) {
					return;
				}

				moveEvent.preventDefault();

				var nextPoint = getEventPoint(moveEvent);
				var dx = nextPoint.x - dragging.startX;
				var dy = nextPoint.y - dragging.startY;
				var nextRect =
					dragging.mode === 'move'
						? calculateMovedSelection(dragging.startRect, dx, dy)
						: calculateResizedSelection(dragging.handle, dragging.startRect, dx, dy);

				cropper.selection = nextRect;
				renderSelection();
			})
			.on('pointerup' + pointerNamespace + ' pointercancel' + pointerNamespace, function () {
				stopDragging();
			});
	};

	var buildCropper = function (imageUrl, imageMeta) {
		var $content = $('#' + jcrop_face + ' .jcrop-face-content');
		var stageHtml = [
			'<div class="jcrop-face-stage">',
			'<div class="jcrop-face-image-wrap">',
			'<img id="' + jcrop_face_img + '" src="' + imageUrl + '" alt="" />',
			'<div class="jcrop-face-selection">',
			'<span class="jcrop-face-handle jcrop-face-handle-nw" data-dir="nw"></span>',
			'<span class="jcrop-face-handle jcrop-face-handle-ne" data-dir="ne"></span>',
			'<span class="jcrop-face-handle jcrop-face-handle-sw" data-dir="sw"></span>',
			'<span class="jcrop-face-handle jcrop-face-handle-se" data-dir="se"></span>',
			'</div>',
			'</div>',
			'</div>'
		].join('');

		destroyCropper();
		$content.show().html(stageHtml);

		var $stage = $content.find('.jcrop-face-stage');
		var $imageWrap = $content.find('.jcrop-face-image-wrap');
		var stageWidth = $stage.innerWidth() || $content.innerWidth() || 460;
		var stageHeight = $stage.innerHeight() || $content.innerHeight() || 400;
		var scale = Math.min(
			stageWidth / imageMeta.width,
			stageHeight / imageMeta.height,
			1
		);
		var displayWidth = Math.round(imageMeta.width * scale);
		var displayHeight = Math.round(imageMeta.height * scale);
		var cropImageScale = Math.min(460 / imageMeta.width, 400 / imageMeta.height, 1);

		cropper = {
			scale: scale,
			cropImageScale: cropImageScale,
			displayWidth: displayWidth,
			displayHeight: displayHeight,
			$imageWrap: $imageWrap,
			$image: $('#' + jcrop_face_img),
			$selection: $content.find('.jcrop-face-selection'),
			selection: null
		};

		$imageWrap.css({
			width: displayWidth + 'px',
			height: displayHeight + 'px'
		});

		cropper.$image.css({
			width: displayWidth + 'px',
			height: displayHeight + 'px'
		});

		cropper.selection = createInitialSelection();
		renderSelection();

		cropper.$selection.on('pointerdown', function (event) {
			if ($(event.target).closest('.jcrop-face-handle').length) {
				return;
			}

			event.preventDefault();
			startDragging('move', '', event);
		});

		cropper.$selection.find('.jcrop-face-handle').on('pointerdown', function (event) {
			event.preventDefault();
			event.stopPropagation();
			startDragging('resize', $(this).data('dir'), event);
		});
	};

	var uploadInst = upload.render({
		elem: '#' + upload_image_btn,
		url: uploadUrl,
		accept: 'images',
		exts: exts || 'jpg|gif|png|jpeg|pneg|webp|bmp',
		field: field || 'file',
		acceptMime:
			acceptMime || 'image/png,image/gif,image/jpeg,image/webp,image/bmp',
		headers: headers || '',
		size: size || 2 * 1024 * 1024,
		data: uploadData || '',
		before: function () {
			$('#' + jcrop_face + ' .jcrop-face-error').text('').hide();
			$('#' + upload_image_msg).text('').hide();
			$('#' + upload_image_btn).html(
				"<i class='layui-icon layui-anim layui-anim-rotate layui-anim-loop'>&#xe63d;</i>" +
					t('uploading', '正在上传中...')
			);
		},
		done: function (result) {
			$('#' + upload_image_btn).html(
				"<i class='layui-icon'>&#xe654;</i>" + t('uploadImage', '上传图片')
			);

			if (result.code == 0) {
				$('#' + jcrop_face + ' .jcrop-face-upload').hide();
				$('#' + jcrop_face + ' .jcrop-face-content').show();
				$('#' + jcrop_face_big + ' .jcrop-face-container').html(
					"<img src='" + result.data.path + "'/>"
				);

				if (type_small) {
					$('#' + jcrop_face_small + ' .jcrop-face-container').html(
						"<img src='" + result.data.path + "'/>"
					);
				}

				jcrop_id = result.data.id;

				loadImage(
					result.data.path,
					function (img) {
						buildCropper(result.data.path, img);
					},
					function () {}
				);
			} else {
				$('#' + upload_image_msg).text(result.msg).show();
			}
		},
		error: function () {
			$('#' + upload_image_btn).html(
				"<i class='layui-icon'>&#xe654;</i>" + t('uploadImage', '上传图片')
			);
			$('#' + upload_image_msg).text(t('networkError', '网络异常')).show();
		}
	});

	var resetPanel = function () {
		destroyCropper();
		$('#' + jcrop_face + ' .jcrop-face-content').empty().hide();
		$('#' + jcrop_face_big + ' .jcrop-face-container').empty();

		if (type_small) {
			$('#' + jcrop_face_small + ' .jcrop-face-container').empty();
		}

		$('#' + jcrop_face + ' .jcrop-face-upload').show();
		$('#' + jcrop_face + ' .jcrop-face-error').text('').hide();
		$('#' + jcrop_face + ' .jcrop-face-success').text(t('confirm', '确定'));
		jcrop_id = 0;
		clearPreview();
	};

	$('#' + jcrop_face + ' .jcrop-face-reset').click(function () {
		resetPanel();
		return false;
	});

	$('#' + jcrop_face + ' .jcrop-face-close').click(function () {
		resetPanel();
		layer.close(this._state.layerIndex);
		return false;
	}.bind(this));

	$('#' + jcrop_face + ' .jcrop-face-success').click(function (event) {
		var instance = this;
		var $button = $(event.currentTarget);

		if (isCropping) {
			return false;
		}

		if (jcrop_w === 0 && jcrop_h === 0) {
			$('#' + jcrop_face + ' .jcrop-face-error')
				.text(
					cropper
						? t('selectCropArea', '请选择裁剪区域')
						: t('uploadFirst', '请先上传图片')
				)
				.show();
			return false;
		}

		isCropping = true;
		$button.html(
			"<i class='layui-icon layui-anim layui-anim-rotate layui-anim-loop'>&#xe63d;</i>"
		);

		cropType = type_small ? type_big + ',' + type_small : type_big;

		$.ajax({
			type: 'post',
			url: cropUrl,
			data: {
				x: jcrop_x,
				y: jcrop_y,
				w: jcrop_w,
				h: jcrop_h,
				id: jcrop_id,
				type: cropType,
				object_type: object_type
			},
			dataType: 'json',
			success: function (result) {
				isCropping = false;
				if (result.code == 0) {
					(callback && typeof callback === 'function') &&
						callback(result.data.id, result.data.src[0]);
					$button.html(t('confirm', '确定'));
					resetPanel();
					layer.close(instance._state.layerIndex);
				} else {
					resetPanel();
					$('#' + jcrop_face + ' .jcrop-face-error').text(result.msg).show();
					$button.html(t('confirm', '确定'));
				}
			},
			error: function () {
				isCropping = false;
				$button.html(t('confirm', '确定'));
				$('#' + jcrop_face + ' .jcrop-face-error')
					.text(t('networkError', '网络异常'))
					.show();
			}
		});

		return false;
	}.bind(this));
};

jcropFace.prototype.render = function () {
	var jcrop_face = this.options.elem + '_jcrop_face';
	var metrics = getDialogMetrics();

	$('#' + jcrop_face).css({
		'--jcrop-dialog-height': metrics.dialogHeight,
		'--jcrop-stage-height': metrics.stageHeight
	});

	this._state = this._state || {
		layerIndex: null
	};
	this._state.layerIndex = layer.open({
		type: 1,
		shadeClose: false,
		title: false,
		area: metrics.area,
		resize: false,
		move: '#' + jcrop_face + ' .jcrop-face-move',
		shade: 0.8,
		content: $('#' + jcrop_face),
		skin: 'layer-g3ys-default',
		end: function () {
			this._state.layerIndex = null;
		}.bind(this)
	});
};

export { JcropFace as jcropFace };
